import * as React from "react";
const Tag = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M15.545 9.326a1.12 1.12 0 110-2.241 1.12 1.12 0 010 2.241z" />
      <path fillRule="evenodd" d="M11.08 21.089c-.417.42-1 .662-1.592.66a2.257 2.257 0 01-1.593-.66l-5.234-5.234c-.418-.419-.66-1.001-.66-1.593s.242-1.174.66-1.592l9.01-9.01A2.266 2.266 0 0113.264 3h5.234a2.254 2.254 0 012.252 2.252v5.234a2.265 2.265 0 01-.661 1.594zM13.264 4.5c-.2 0-.39.08-.532.22l-9.01 9.01a.752.752 0 000 1.063l5.234 5.235a.768.768 0 001.063 0l9.01-9.01a.755.755 0 00.221-.532V5.252a.753.753 0 00-.752-.752z" clipRule="evenodd" />
    </g>
  </symbol>;
export default Tag;